import React, { useState, useEffect, useRef } from "react";
import "./ApprovalWorkflow.css";
import { useNavigate } from 'react-router-dom';
import ApprovalHero from "./ApprovalHero";
import ApprovalWiseCode from "./ApprovalWiseCode";
import HRCopilotFeatures from './HRCopilotFeatures';
import HRCopilotNewsSection from "./HRCopilotNewsSection";



const VideoPopup = ({ isOpen, onClose, videoUrl }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      if (videoRef.current) {
        videoRef.current.currentTime = 0;
      }
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="approval-video-popup-overlay" onClick={onClose}>
      <div className="approval-video-popup-content" onClick={(e) => e.stopPropagation()}>
        <button className="approval-video-popup-close" onClick={onClose}>
          ×
        </button>
        <div className="approval-video-container">
          <video ref={videoRef} controls autoPlay className="approval-demo-video">
            <source src={videoUrl} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
        <div className="approval-video-popup-info">
          <h3>Approval Workflow Platform</h3>
          <p>See how our approval workflow system streamlines decision-making and accelerates business processes</p>
        </div>
      </div>
    </div>
  );
};

const ApprovalWorkflow = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isVideoPopupOpen, setIsVideoPopupOpen] = useState(false);
  const [activeFeature, setActiveFeature] = useState(0);
  const [scrollProgress, setScrollProgress] = useState(0);
  const navigate = useNavigate();
 const videoRef = useRef(null);
  const [scrollY, setScrollY] = useState(0);
    const handleAccessRecruit = () => navigate('/access-recruit');

  useEffect(() => {
    setIsVisible(true);
    
    // Auto rotate features
    const interval = setInterval(() => {
      setActiveFeature(prev => (prev + 1) % 6);
    }, 4000);
    
    // Scroll progress
    const handleScroll = () => {
      const scrollTop = window.pageYOffset;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const progress = (scrollTop / docHeight) * 100;
      setScrollProgress(progress);
    };

    window.addEventListener('scroll', handleScroll);
    
    return () => {
      clearInterval(interval);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const demoVideoUrl = "https://assets.mixkit.co/videos/preview/mixkit-businessman-signing-a-document-41559-large.mp4";

  const openVideoPopup = () => {
    setIsVideoPopupOpen(true);
  };

  const closeVideoPopup = () => {
    setIsVideoPopupOpen(false);
  };

  const handleAccessApproval = () => navigate('/payment');
 


const openApprovalVideoPopup = () => {
  // Open approval management video popup
  console.log("Open approval management video");
};

  const features = [
    {
      icon: "⚡",
      title: "Automated Routing",
      description: "Intelligent routing of requests to the right approvers based on rules, roles, and availability"
    },
    {
      icon: "📱",
      title: "Mobile Approvals",
      description: "Approve or reject requests from any device with real-time notifications and mobile-friendly interface"
    },
    {
      icon: "🔄",
      title: "Multi-level Workflows",
      description: "Create complex approval chains with parallel, sequential, and conditional approval paths"
    },
    {
      icon: "📊",
      title: "Real-time Analytics",
      description: "Track approval metrics, identify bottlenecks, and optimize workflow performance"
    },
    {
      icon: "🔔",
      title: "Smart Escalations",
      description: "Automatic escalations and reminders for pending approvals to ensure timely decisions"
    },
    {
      icon: "🛡️",
      title: "Compliance & Audit",
      description: "Complete audit trails, compliance reporting, and regulatory requirement management"
    }
  ];

const approvalStages = [
  {
    phase: "Submission",
    icon: "📝",
    time: "Instant",
    title: "Request Submission & Validation",
    steps: [
      "Automated form validation",
      "Required field completion",
      "Attachment verification",
      "Initial compliance check"
    ]
  },
  {
    phase: "Routing",
    icon: "🔄",
    time: "2-5 minutes",
    title: "Intelligent Approval Routing",
    steps: [
      "AI-powered approver selection",
      "Multi-level routing configuration",
      "Delegation rules application",
      "Escalation path setup"
    ]
  },
  {
    phase: "Review",
    icon: "👥",
    time: "Real-time",
    title: "Collaborative Review Process",
    steps: [
      "Multi-stakeholder collaboration",
      "Comment and feedback collection",
      "Version tracking and history",
      "Real-time status updates"
    ]
  },
  {
    phase: "Decision",
    icon: "✅",
    time: "Automated",
    title: "Final Decision & Action",
    steps: [
      "Automated approval workflows",
      "Conditional logic execution",
      "Notification and alert system",
      "Audit trail generation"
    ]
  }
];

const approvalMetrics = [
  { name: "Expense Approvals", progress: 92 },
  { name: "Purchase Requests", progress: 85 },
  { name: "Leave Requests", progress: 78 },
  { name: "Contract Approvals", progress: 67 }
];

const approvalIntegrations = [
  "SAP", "Oracle", "Workday", "Salesforce", 
  "ServiceNow", "Slack", "Microsoft Teams", "Jira", 
  "Confluence", "QuickBooks", "Zapier", "API"
];



  return (
    <div className="approval-container">
      {/* Scroll Progress Bar */}
      {/* <div className="approval-scroll-progress" style={{width: `${scrollProgress}%`}}></div> */}

      {/* Video Popup */}
      <VideoPopup 
        isOpen={isVideoPopupOpen} 
        onClose={closeVideoPopup} 
        videoUrl={demoVideoUrl}
      />

      {/* Enhanced Animated Background */}
      <div className="approval-background-animation">
        {/* <div className="approval-floating-shape approval-shape-1"></div>
        <div className="approval-floating-shape approval-shape-2"></div>
        <div className="approval-floating-shape approval-shape-3"></div>
        <div className="approval-floating-shape approval-shape-4"></div>
        <div className="approval-floating-shape approval-shape-5"></div> */}
        
        {/* Animated Gradient Orbs */}
        {/* <div className="approval-gradient-orb approval-orb-1"></div>
        <div className="approval-gradient-orb approval-orb-2"></div>
        <div className="approval-gradient-orb approval-orb-3"></div> */}
        
        {/* SVG Background Animation */}
        <svg className="approval-bg-svg" viewBox="0 0 100 100" preserveAspectRatio="none">
          <defs>
            <linearGradient id="approval-gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="rgba(74, 144, 226, 0.08)" />
              <stop offset="50%" stopColor="rgba(120, 119, 216, 0.05)" />
              <stop offset="100%" stopColor="rgba(226, 74, 144, 0.08)" />
            </linearGradient>
            <linearGradient id="approval-gradient2" x1="100%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="rgba(120, 119, 216, 0.06)" />
              <stop offset="50%" stopColor="rgba(119, 216, 216, 0.04)" />
              <stop offset="100%" stopColor="rgba(74, 226, 144, 0.06)" />
            </linearGradient>
            <pattern id="approval-grid" width="10" height="10" patternUnits="userSpaceOnUse">
              <path d="M 10 0 L 0 0 0 10" fill="none" stroke="rgba(255,255,255,0.05)" strokeWidth="0.5"/>
            </pattern>
          </defs>
          <rect width="100" height="100" fill="url(#approval-grid)" />
          <path 
            d="M0,15 Q30,5 60,25 T100,35 L100,100 L0,100 Z" 
            fill="url(#approval-gradient1)"
            className="approval-svg-path-1"
          />
          <path 
            d="M0,65 Q40,45 80,70 T100,85 L100,100 L0,100 Z" 
            fill="url(#approval-gradient2)"
            opacity="0.8"
            className="approval-svg-path-2"
          />
        </svg>
      </div>


<ApprovalHero/>
<ApprovalWiseCode/>
<HRCopilotFeatures/>
<HRCopilotNewsSection/>

{/* Approval Management CTA */}

    </div>
  );
};

export default ApprovalWorkflow;